/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSaveCardSession200ResponseAnyOf } from './CreateSaveCardSession200ResponseAnyOf';
import {
    CreateSaveCardSession200ResponseAnyOfFromJSON,
    CreateSaveCardSession200ResponseAnyOfFromJSONTyped,
    CreateSaveCardSession200ResponseAnyOfToJSON,
    CreateSaveCardSession200ResponseAnyOfToJSONTyped,
} from './CreateSaveCardSession200ResponseAnyOf';
import type { CreateSaveCardSession200ResponseAnyOf1 } from './CreateSaveCardSession200ResponseAnyOf1';
import {
    CreateSaveCardSession200ResponseAnyOf1FromJSON,
    CreateSaveCardSession200ResponseAnyOf1FromJSONTyped,
    CreateSaveCardSession200ResponseAnyOf1ToJSON,
    CreateSaveCardSession200ResponseAnyOf1ToJSONTyped,
} from './CreateSaveCardSession200ResponseAnyOf1';
import type { CreateSaveCardSession200ResponseAnyOfIntent } from './CreateSaveCardSession200ResponseAnyOfIntent';
import {
    CreateSaveCardSession200ResponseAnyOfIntentFromJSON,
    CreateSaveCardSession200ResponseAnyOfIntentFromJSONTyped,
    CreateSaveCardSession200ResponseAnyOfIntentToJSON,
    CreateSaveCardSession200ResponseAnyOfIntentToJSONTyped,
} from './CreateSaveCardSession200ResponseAnyOfIntent';
import type { CreateSaveCardSession200ResponseAnyOfClientConfig } from './CreateSaveCardSession200ResponseAnyOfClientConfig';
import {
    CreateSaveCardSession200ResponseAnyOfClientConfigFromJSON,
    CreateSaveCardSession200ResponseAnyOfClientConfigFromJSONTyped,
    CreateSaveCardSession200ResponseAnyOfClientConfigToJSON,
    CreateSaveCardSession200ResponseAnyOfClientConfigToJSONTyped,
} from './CreateSaveCardSession200ResponseAnyOfClientConfig';
import type { CreateSaveCardSession200ResponseAnyOfAmount } from './CreateSaveCardSession200ResponseAnyOfAmount';
import {
    CreateSaveCardSession200ResponseAnyOfAmountFromJSON,
    CreateSaveCardSession200ResponseAnyOfAmountFromJSONTyped,
    CreateSaveCardSession200ResponseAnyOfAmountToJSON,
    CreateSaveCardSession200ResponseAnyOfAmountToJSONTyped,
} from './CreateSaveCardSession200ResponseAnyOfAmount';

/**
 * 
 * @export
 * @interface CreateSaveCardSession200Response
 */
export interface CreateSaveCardSession200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200Response
     */
    provider: CreateSaveCardSession200ResponseProviderEnum;
    /**
     * 
     * @type {CreateSaveCardSession200ResponseAnyOfClientConfig}
     * @memberof CreateSaveCardSession200Response
     */
    clientConfig: CreateSaveCardSession200ResponseAnyOfClientConfig;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200Response
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200Response
     */
    sessionData: string;
    /**
     * 
     * @type {CreateSaveCardSession200ResponseAnyOfAmount}
     * @memberof CreateSaveCardSession200Response
     */
    amount?: CreateSaveCardSession200ResponseAnyOfAmount;
    /**
     * 
     * @type {CreateSaveCardSession200ResponseAnyOfIntent}
     * @memberof CreateSaveCardSession200Response
     */
    intent?: CreateSaveCardSession200ResponseAnyOfIntent;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200Response
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200Response
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200Response
     */
    publishableKey: string;
}


/**
 * @export
 */
export const CreateSaveCardSession200ResponseProviderEnum = {
    Stripe: 'stripe'
} as const;
export type CreateSaveCardSession200ResponseProviderEnum = typeof CreateSaveCardSession200ResponseProviderEnum[keyof typeof CreateSaveCardSession200ResponseProviderEnum];


/**
 * Check if a given object implements the CreateSaveCardSession200Response interface.
 */
export function instanceOfCreateSaveCardSession200Response(value: object): value is CreateSaveCardSession200Response {
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('clientConfig' in value) || value['clientConfig'] === undefined) return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    if (!('sessionData' in value) || value['sessionData'] === undefined) return false;
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('publishableKey' in value) || value['publishableKey'] === undefined) return false;
    return true;
}

export function CreateSaveCardSession200ResponseFromJSON(json: any): CreateSaveCardSession200Response {
    return CreateSaveCardSession200ResponseFromJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSaveCardSession200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'clientConfig': CreateSaveCardSession200ResponseAnyOfClientConfigFromJSON(json['clientConfig']),
        'sessionId': json['sessionId'],
        'sessionData': json['sessionData'],
        'amount': json['amount'] == null ? undefined : CreateSaveCardSession200ResponseAnyOfAmountFromJSON(json['amount']),
        'intent': json['intent'] == null ? undefined : CreateSaveCardSession200ResponseAnyOfIntentFromJSON(json['intent']),
        'clientSecret': json['clientSecret'],
        'customerId': json['customerId'],
        'publishableKey': json['publishableKey'],
    };
}

export function CreateSaveCardSession200ResponseToJSON(json: any): CreateSaveCardSession200Response {
    return CreateSaveCardSession200ResponseToJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseToJSONTyped(value?: CreateSaveCardSession200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider': value['provider'],
        'clientConfig': CreateSaveCardSession200ResponseAnyOfClientConfigToJSON(value['clientConfig']),
        'sessionId': value['sessionId'],
        'sessionData': value['sessionData'],
        'amount': CreateSaveCardSession200ResponseAnyOfAmountToJSON(value['amount']),
        'intent': CreateSaveCardSession200ResponseAnyOfIntentToJSON(value['intent']),
        'clientSecret': value['clientSecret'],
        'customerId': value['customerId'],
        'publishableKey': value['publishableKey'],
    };
}

